import { render, staticRenderFns } from "./WarehouseTransfer.vue?vue&type=template&id=2e20bc72&scoped=true"
import script from "./WarehouseTransfer.vue?vue&type=script&lang=js"
export * from "./WarehouseTransfer.vue?vue&type=script&lang=js"
import style0 from "./WarehouseTransfer.vue?vue&type=style&index=0&id=2e20bc72&prod&scoped=true&lang=css"
import style1 from "./WarehouseTransfer.vue?vue&type=style&index=1&id=2e20bc72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e20bc72",
  null
  
)

export default component.exports